import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { Home, Maintenance } from "./pages";
import "./theme/reset.css";
import { ProfileProvider } from "./context/ProfilContext";
import FooterWithProfile from "./containers/FooterWithProfile";

export default function App() {
  const isMaintenanceMode = process.env.REACT_APP_MAINTENANCE_MODE === "true";

  return (
    <ProfileProvider>
      <Router>
        {isMaintenanceMode ? (
          <Maintenance />
        ) : (
          <Switch>
            <Route exact path="/">
              <Home />
            </Route>
          </Switch>
        )}
        <FooterWithProfile />
      </Router>
    </ProfileProvider>
  );
}
